import React, { useCallback } from "react";
import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { TextField, Typography } from "@totalsoft/rocket-ui";
import { DateTime } from "@ts-private/rocket-extensions";

const FiltersPartnerLog = ({ filters, onChangeFilterValue }) => {
  const { t } = useTranslation();

  const onFilterChange = useCallback(
    name => value => {
      onChangeFilterValue(name, value);
    },
    [onChangeFilterValue]
  );

  return (
    <Grid item container xs={12} spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body1">{t("PartnerLog.FiltersTitle")}</Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <DateTime
          fullWidth
          id="partnerLogs_filters_startDate"
          label={t("PartnerLog.StartDate")}
          value={filters.startDate}
          onChange={onFilterChange("startDate")}
          isClearable
          timeFormat={false}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <DateTime
          fullWidth
          id={"partnerLogs_filters_endDate"}
          value={filters.endDate}
          label={t("PartnerLog.EndDate")}
          onChange={onFilterChange("endDate")}
          isClearable
          timeFormat={false}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <TextField
          fullWidth
          id="partnerLogs_filters_userName"
          label={t("PartnerLog.UserName")}
          value={filters.userName}
          onChange={onFilterChange("userName")}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <TextField
          fullWidth
          id="partnerLogs_filters_changeType"
          label={t("PartnerLog.ChangeType")}
          value={filters.changeType}
          onChange={onFilterChange("changeType")}
        />
      </Grid>
    </Grid>
  );
};

FiltersPartnerLog.propTypes = {
  filters: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired
};

export default FiltersPartnerLog;
